import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { HeaderViewServices } from 'v2/resources/services/headerView';
import { IResponseHeaderView } from 'v2/resources/types/headerView';

const useHeaderView = (
  nameProperty: string
): UseQueryResult<IResponseHeaderView> => {
  return useQuery({
    queryKey: ['getHeaderView', nameProperty],
    queryFn: () => HeaderViewServices.getHeaderView(),

    enabled: true,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
};

export default useHeaderView;
